import { Button, Col, Divider, Form, Input, Row, Select, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import mealApi from '../../api/meal.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { userState } from '../../store/user'
import styles from '../../styles/product.module.scss'
import { mealCategory } from './modeal'

const MealListPage = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(false)
  const [searchOptions, setSearchOptions] = useState({
    mealName: '',
    mealCategoryId: null,
  })
  const [mealItemList, setMealItemList] = useState([])
  const [pagination, setPagination] = useState({
    pageNumber: 0,
    pageSize: 10,
    totalElements: 0,
  })
  const [selectedRowKey, setSelectedRowKey] = useState([])

  const rowSelection = {
    type: 'radio',
    selectedRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKey(selectedRowKeys)
    },
  }

  const columns = [
    {
      title: '식사 ID',
      width: 100,
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      fixed: 'left',
    },
    {
      title: '카테고리',
      width: 120,
      dataIndex: 'categoryName',
      key: 'categoryName',
      ellipsis: true,
      render: (value, record) => {
        const category = mealCategory.find(
          (cat) => cat.id === record.mealCategoryId,
        )
        return category ? category.categoryName : '-'
      },
    },
    {
      title: '식사명',
      width: 150,
      dataIndex: 'mealName',
      key: 'mealName',
      ellipsis: true,
    },
    {
      title: '이미지 미리보기',
      width: 150,
      dataIndex: 'mealImageLink',
      key: 'mealImageLink',
      ellipsis: true,
      render: (value) => (
        <div>
          {value ? (
            <img
              src={value}
              alt="mealImageLink"
              style={{
                width: 45,
                height: 45,
                objectFit: 'cover',
                borderRadius: 4,
              }}
            />
          ) : (
            '-'
          )}
        </div>
      ),
    },
  ]

  const handleChange = (name, value) => {
    setSearchOptions({ ...searchOptions, [name]: value })
  }

  const handleSearchBtnClick = () => {
    setPagination({
      ...pagination,
      pageNumber: 0,
    })
    getAllMealList(0, pagination.pageSize, searchOptions)
  }

  const handleInitialBtnClick = () => {
    setSearchOptions({
      mealName: '',
      mealCategoryId: null,
    })
    setPagination({
      ...pagination,
      pageNumber: 0,
    })
    getAllMealList(0, pagination.pageSize, {
      mealName: '',
      mealCategoryId: null,
    })
  }

  const handleChangePagination = (pageNumber, pageSize) => {
    getAllMealList(
      pageNumber - 1,
      pageSize || pagination.pageSize,
      searchOptions,
    )
  }

  const pageSizeChange = (current, pageSize) => {
    getAllMealList(0, pageSize, searchOptions)
  }

  const getAllMealList = async (page = 0, size = 10, searchParams = {}) => {
    setIsLoading(true)
    try {
      const params = {
        page,
        size,
        ...searchParams,
      }
      const res = await mealApi.getMealList(params)
      if (res.status === 200) {
        setMealItemList(res.data.content || [])
        setPagination({
          pageNumber: res.data.pageable?.pageNumber || page,
          pageSize: res.data.pageable?.pageSize || size,
          totalElements: res.data.totalElements || 0,
        })
      }
    } catch (error) {
      console.error('getAllMealList error:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getAllMealList()
  }, [])

  return (
    <>
      <ContentHeader title="음식 리스트 관리" />
      <div
        className={styles['product-register-wrap']}
        style={{ minWidth: '1024px' }}
      >
        {/* 상태 카운트 */}
        <Row
          justify="space-around"
          className={styles['product-search-product-status-wrap']}
        >
          <Col className={styles['product-status-box-col-wrap']} span={8}>
            <Row className={styles['product-status-box-wrap']}>
              <div className={styles['product-status-text']}>
                <div>전체</div>
                <div>
                  <span className={styles['product-status-num']}>
                    {pagination.totalElements}
                  </span>{' '}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        {/* 검색 영역 */}
        <div className={styles['product-search-box-wrap']}>
          <Form.Item
            label="검색어"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" style={{ marginBottom: 15 }}>
              <label className={styles['product-search-box-input-label']}>
                음식명
              </label>
              <Input
                className={styles['product-search-box-input-wrap']}
                name="mealName"
                value={searchOptions.mealName}
                onChange={(e) => handleChange('mealName', e.target.value)}
                onPressEnter={handleSearchBtnClick}
                placeholder="음식명을 입력하세요"
              />
            </Row>
          </Form.Item>

          <Divider className={styles['product-register-form-input-divider']} />

          <Form.Item
            className={styles['center-label']}
            label="카테고리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              style={{ width: 200 }}
              placeholder="카테고리를 선택하세요"
              allowClear
              value={searchOptions.mealCategoryId}
              onChange={(value) => handleChange('mealCategoryId', value)}
              options={[
                { label: '전체', value: null },
                ...mealCategory.map((item) => ({
                  label: item.categoryName,
                  value: item.id,
                })),
              ]}
            />
          </Form.Item>

          <Divider className={styles['product-register-form-input-divider']} />

          <Row
            className={styles['product-search-button-wrap']}
            justify="center"
          >
            <Button
              className={`${styles['product-search-button']} ${styles.search}`}
              onClick={handleSearchBtnClick}
            >
              검색
            </Button>
            <Button
              className={`${styles['product-search-button']} ${styles.initial}`}
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/* 목록 */}
        <Row
          className={styles['product-register-border-box']}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <span className={styles['product-register-box-title']}>
            음식 목록 (총{' '}
            <span
              className={styles['product-register-box-subtitle']}
              style={{ marginLeft: 0 }}
            >
              {pagination.totalElements}
            </span>
            개)
          </span>
        </Row>

        <div
          className={styles['product-register-border-box']}
          style={{ padding: '20px 25px 40px', height: 'fit-content' }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={mealItemList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="id"
            onRow={(record) => ({
              onClick: () => navigate(`/meals/${record.id}`),
              style: { cursor: 'pointer' },
            })}
            pagination={{
              current: pagination.pageNumber + 1,
              pageSize: pagination.pageSize,
              total: pagination.totalElements,
              onChange: handleChangePagination,
              onShowSizeChange: pageSizeChange,
              showQuickJumper: true,
              showSizeChanger: true,
            }}
          />
        </div>
      </div>
    </>
  )
}

export default MealListPage
